import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CertificateSharingKind,
  OrganisationCertificatePreview,
  ShareableOrganisation,
  ShareOrganisationCertificatesRequest,
  ShareOrganisationCertificatesResponse,
} from './certificate-sharing.models';

@Injectable({ providedIn: 'root' })
export class CertificateSharingService {
  private http = inject(HttpClient);

  private baseUrl(kind: CertificateSharingKind): string {
    return `/api/v1/certificate-sharing/${kind}`;
  }

  /** Organisations with at least one current certificate (GL users only see their own organisations) */
  getShareableOrganisations(kind: CertificateSharingKind): Observable<ShareableOrganisation[]> {
    return this.http.get<ShareableOrganisation[]>(`${this.baseUrl(kind)}/organisations`);
  }

  /** Current certificates and possible recipients of one organisation */
  getOrganisationCertificatePreview(
    kind: CertificateSharingKind,
    organisationId: string
  ): Observable<OrganisationCertificatePreview> {
    return this.http.get<OrganisationCertificatePreview>(`${this.baseUrl(kind)}/organisations/${organisationId}`);
  }

  /** ZIP of all current certificates of one organisation (direct download, no email) */
  downloadOrganisationCertificates(kind: CertificateSharingKind, organisationId: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.baseUrl(kind)}/organisations/${organisationId}/download`, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  /** Email all current certificates of one organisation to the selected recipients */
  shareOrganisationCertificates(
    kind: CertificateSharingKind,
    organisationId: string,
    request: ShareOrganisationCertificatesRequest
  ): Observable<ShareOrganisationCertificatesResponse> {
    return this.http.post<ShareOrganisationCertificatesResponse>(
      `${this.baseUrl(kind)}/organisations/${organisationId}/share`,
      request
    );
  }
}
